import PropTypes from 'prop-types'

const BiasedJudgementSimPropType = PropTypes.arrayOf(
  PropTypes.number,
)

export default BiasedJudgementSimPropType